import React from 'react';
import styled from 'styled-components';
import Button from './Button';

interface ButtonTextGroupProps {
  title: string;
  buttonText: string;
  width?: any;
  href?: string;
  onClick?: () => void;
  className?: string;
}

const Container = styled.div<{ width: number }>`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width};
`;

const Title = styled.span`
  font-family: Arial;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const ButtonTextGroup: React.FC<ButtonTextGroupProps> = ({
  title,
  buttonText,
  width = '100%',
  href,
  onClick,
}) => {
  return (
    <Container width={width}>
      <Title>{title}</Title>
      <a href={href} onClick={onClick}>
        <Button height="42px" className={`itvTheme`}>
          {buttonText}
        </Button>
      </a>
    </Container>
  );
};

export default ButtonTextGroup;
